import React, { useState, useEffect } from "react";
import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import CustomerTable from "../customerTable";
import CustomerAddModal from "../customerAddModal";

import useMembersStore from "../../store/members.store";
import useClientStore from "../../store/clientModal.store";
import NewRTableSelectable from "../NewRTableSelectable";

import "./customers.scss";

const allcustomerTitles = [
  "Select",
  "S. No.",
  "Customer Name",
  "Company Type",
  "HQ Location",
  "Description",
  "View",
  "Status",
  "Date Added",
];


function Customers() {
    const [currentView, setCurrentView] = useState("active");

    const { getClients, clients ,clientsFlag,resetClientsFlag} = useMembersStore();

    const navigate = useNavigate();

    const { setModalOpen } =
        useClientStore();

    useEffect(() => {
        getClients();
    }, []);

    useEffect(() => {
     if(clientsFlag)
        resetClientsFlag()
    }, [clientsFlag]);

  const viewTAs = (name, id) => {
    // navigate(`/specificCustomer/${name}/${id}`);
    navigate(`/specificCustomer/${id}/${name}`, { state: { clientID: id } });
  };

    const clientList =
         clients && clients.length > 0
            ? clients.map((client, idx) => ({
          select: "",
                  id: idx + 1,
                  name: client?.ClientName,
                  type: client?.ClientType,
                  location: client?.ClientLocation,
                  description: client?.ClientDescription,                  
                  talist:(
                    <div
                        style={{
                            cursor: "pointer",
                            color: "blue",
                            fontWeight: "600",
                        }}
                        onClick={() => viewTAs(client?.ClientName,idx)}
                    >
                        View 
                    </div>
                  ),
                  state: client?.ClientState,
                  date : client?.ClientAdditionDate,                  
        }))
      : [];

    const handleAddTeamClick = () => {
        setModalOpen();
    };

    return (
        <div className="customers-container">
            <div className="customers-btns-wrapper">
                <Button
                    onClick={() => setCurrentView("active")}
                    className={`customer-btn ${
                        currentView === "active" && "customer-btn-active"
                    }`}
                >
                    Active List
                </Button>
                <Button
                    onClick={() => setCurrentView("all")}
                    className={`customer-btn ${
                        currentView === "all" && "customer-btn-active"
                    }`}
                >
                    All List
                </Button>
            </div>
            <div className="customer-members-wrapper">
                    <div style={{display:"flex"}}>
                    {
                        currentView === "active"?
                        <>
                            <h2 className="customer-members-list-title">List of Active Cutomers</h2>
                        </>
                        :<>
                            <h2 className="customer-members-list-title">List of All Cutomers</h2>
                        </>
                    }
                   
                    <div className="customer-members-add-wrapper">
                        <Button
                            onClick={handleAddTeamClick}
                            type="primary"
                            className="customer-members-add-btn"
                        >
                            + New Customer
                        </Button>
                    </div>
                    </div>
                    {currentView === "active"? (
                       <CustomerTable
                            titleList={allcustomerTitles}
                            data={clientList}
                        />
                    ) : (
                        <NewRTableSelectable
                           titleList={allcustomerTitles} 
                           data={clientList} 
                        />
                    )}

                  
            </div>            
            <CustomerAddModal />
        </div>
    );
}

export default Customers;
